(() => {
  'use strict';
  const init = () => {
    const root = document.getElementById('mw-tumbler');
    if (!root || root.dataset.ready) return;
    root.dataset.ready = 'true';
    const config = JSON.parse(root.querySelector('[data-tumbler-config]').textContent);
    const $ = (s) => root.querySelector(s);
    const $$ = (s) => [...root.querySelectorAll(s)];
    const abort = new AbortController();
    const on = (el, name, fn, options = {}) => el?.addEventListener(name, fn, {...options, signal: abort.signal});
    const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
    const track = $('.tm-gallery-track');
    const slides = $$('.tm-slide');
    const thumbs = $$('[data-gallery-go]');
    const modal = $('.tm-lightbox');
    const modalImage = modal.querySelector('img');
    let index = 0;
    let modalIndex = 0;
    let previousFocus;
    let oldBodyOverflow = '';
    const normalized = (n) => (n + slides.length) % slides.length;
    const updateGallery = () => {
      index = Math.max(0, Math.min(slides.length - 1, Math.round(track.scrollLeft / track.clientWidth)));
      $('[data-gallery-count]').textContent = String(index + 1);
      thumbs.forEach((b, i) => b.setAttribute('aria-pressed', String(i === index)));
      const activeThumb = thumbs[index];
      const thumbTrack = $('.tm-gallery-thumbs');
      if (activeThumb && thumbTrack.scrollWidth > thumbTrack.clientWidth) {
        thumbTrack.scrollTo({left:activeThumb.offsetLeft - thumbTrack.offsetLeft - (thumbTrack.clientWidth - activeThumb.offsetWidth) / 2, behavior:'instant'});
      }
    };
    const go = (n) => {
      index = normalized(n);
      track.scrollTo({left: index * track.clientWidth, behavior: reduceMotion.matches ? 'instant' : 'smooth'});
    };
    on(track, 'scroll', updateGallery, {passive: true});
    on($('.tm-gallery-arrow--prev'), 'click', () => go(index - 1));
    on($('.tm-gallery-arrow--next'), 'click', () => go(index + 1));
    thumbs.forEach((b, i) => on(b, 'click', () => go(i)));
    on(track, 'keydown', (e) => {
      if (!['ArrowLeft', 'ArrowRight', 'Home', 'End'].includes(e.key)) return;
      e.preventDefault();
      go(e.key === 'Home' ? 0 : e.key === 'End' ? slides.length - 1 : index + (e.key === 'ArrowRight' ? 1 : -1));
    });
    const showPhoto = (n) => {
      modalIndex = normalized(n);
      const img = slides[modalIndex].querySelector('img');
      modalImage.src = img.currentSrc || img.src;
      modalImage.alt = img.alt;
      $('[data-modal-bundle]').hidden = modalIndex !== 2;
      $('[data-modal-ai]').hidden = modalIndex === 0;
      modalImage.width = img.naturalWidth || 1400;
      modalImage.height = img.naturalHeight || 1400;
    };
    const openModal = (n, button) => {
      previousFocus = button;
      showPhoto(n);
      oldBodyOverflow = document.body.style.overflow;
      document.body.style.overflow = 'hidden';
      modal.showModal();
      $('.tm-lightbox-close').focus();
    };
    slides.forEach((button, i) => on(button, 'click', () => openModal(i, button)));
    on($('.tm-lightbox-close'), 'click', () => modal.close());
    on($('[data-modal-ai]'), 'click', () => modal.close());
    on($('.tm-lightbox-prev'), 'click', () => showPhoto(modalIndex - 1));
    on($('.tm-lightbox-next'), 'click', () => showPhoto(modalIndex + 1));
    on(modal, 'click', (e) => { if (e.target === modal) modal.close(); });
    on(modal, 'close', () => { document.body.style.overflow = oldBodyOverflow; previousFocus?.focus({preventScroll: true}); });
    on(modal, 'keydown', (e) => {
      if (!['ArrowLeft', 'ArrowRight'].includes(e.key)) return;
      e.preventDefault(); showPhoto(modalIndex + (e.key === 'ArrowRight' ? 1 : -1));
    });
    const tempTabs = $$('[data-temperature]');
    const setTemp = (mode, focus = false) => {
      tempTabs.forEach((button) => {
        const active = button.dataset.temperature === mode;
        button.setAttribute('aria-selected', String(active));
        button.tabIndex = active ? 0 : -1;
        if (active && focus) button.focus();
      });
      $('#tm-panel-cold').hidden = mode !== 'cold';
      $('#tm-panel-hot').hidden = mode !== 'hot';
      $('#tm-temperature').dataset.mode = mode;
      $('[data-temp-number]').textContent = mode === 'cold' ? '12' : '6';
      $('[data-temp-unit]').textContent = config.labels[`${mode}_unit`];
      $('[data-temp-symbol]').replaceChildren(tempTabs.find(b => b.dataset.temperature === mode).querySelector('svg').cloneNode(true));
    };
    tempTabs.forEach(button => {
      on(button, 'click', () => setTemp(button.dataset.temperature));
      on(button, 'keydown', (e) => {
        if (!['ArrowLeft', 'ArrowRight', 'Home', 'End'].includes(e.key)) return;
        e.preventDefault(); setTemp(e.key === 'Home' ? 'cold' : e.key === 'End' ? 'hot' : button.dataset.temperature === 'cold' ? 'hot' : 'cold', true);
      });
    });
    $$('[data-detail]').forEach(button => on(button, 'click', () => {
      const selected = button.dataset.detail;
      $$('[data-detail]').forEach(b => b.setAttribute('aria-pressed', String(b.dataset.detail === selected)));
      $$('[data-detail-card]').forEach(card => card.classList.toggle('is-active', card.dataset.detailCard === selected));
      if (button.classList.contains('tm-hotspot') && window.innerWidth < 750) {
        $(`[data-detail-card="${selected}"]`).scrollIntoView({behavior: reduceMotion.matches ? 'instant' : 'smooth', block: 'nearest'});
      }
    }));
    const mobile = window.matchMedia('(max-width: 749px)');
    const serviceItems = $$('.tm-service-item');
    const syncService = () => serviceItems.forEach(item => { item.open = !mobile.matches; });
    syncService(); on(mobile, 'change', syncService);
    $$('a[href="#tm-service-2"]').forEach(link => on(link, 'click', () => { $('#tm-service-2').open = true; }));
    const rail = $('[data-mobile-rail]');
    const railCards = [...rail.children];
    let railIndex = 0;
    const syncRail = () => {
      const step = railCards[1].offsetLeft - railCards[0].offsetLeft;
      railIndex = Math.min(railCards.length - 1, Math.max(0, step > 0 ? Math.round(rail.scrollLeft / step) : 0));
      $('[data-rail-count]').textContent = `${railIndex + 1} / ${railCards.length}`;
      $('[data-rail-prev]').disabled = railIndex === 0;
      $('[data-rail-next]').disabled = railIndex === railCards.length - 1;
    };
    const moveRail = (delta) => {
      const target = Math.min(railCards.length - 1, Math.max(0, railIndex + delta));
      const step = railCards[1].offsetLeft - railCards[0].offsetLeft;
      rail.scrollTo({left: target * step, behavior: reduceMotion.matches ? 'instant' : 'smooth'});
    };
    on(rail, 'scroll', syncRail, {passive:true});
    on(window, 'resize', syncRail, {passive:true});
    on($('[data-rail-prev]'), 'click', () => moveRail(-1));
    on($('[data-rail-next]'), 'click', () => moveRail(1));
    on(rail, 'keydown', e => { if (['ArrowLeft','ArrowRight'].includes(e.key)) { e.preventDefault(); moveRail(e.key === 'ArrowRight' ? 1 : -1); } });
    syncRail();
    const form = $('.tm-form');
    const qty = form.elements.quantity;
    const variantInput = form.elements.id;
    const submit = $('.tm-add');
    const stickyButton = $('[data-sticky-add]');
    const status = $('.tm-cart-status');
    let busy = false;
    const variant = () => config.variants.find(v => String(v.id) === String(variantInput.value));
    const bounds = () => ({min: Number(qty.min) || 1, max: qty.max ? Number(qty.max) : Infinity, step: Number(qty.step) || 1});
    const syncQuantity = () => {
      const {min, max, step} = bounds();
      const value = Number(qty.value);
      qty.value = String(Math.min(max, Math.max(min, min + Math.round(((Number.isFinite(value) ? value : min) - min) / step) * step)));
      const stickyQty = $('[data-sticky-quantity]');
      stickyQty.hidden = Number(qty.value) <= 1;
      stickyQty.textContent = `${qty.value} × `;
      $('[data-quantity="-1"]').disabled = busy || Number(qty.value) <= min;
      $('[data-quantity="1"]').disabled = busy || Number(qty.value) >= max;
    };
    $$('[data-quantity]').forEach(button => on(button, 'click', () => {
      syncQuantity(); qty.value = String(Number(qty.value) + Number(button.dataset.quantity) * bounds().step); syncQuantity();
    }));
    on(qty, 'change', syncQuantity);
    const syncButtons = () => {
      const available = Boolean(variant()?.available);
      [submit, stickyButton].forEach(b => { b.disabled = busy || !available; b.setAttribute('aria-busy', String(busy)); });
      $$('[data-add-label]').forEach(label => { label.textContent = busy ? config.labels.adding : available ? config.labels.add : config.labels.sold_out; });
      qty.disabled = busy;
      if (variantInput.tagName === 'SELECT') variantInput.disabled = busy;
      syncQuantity();
    };
    on(variantInput, 'change', () => {
      const v = variant();
      if (!v) return;
      const money = (value) => new Intl.NumberFormat(config.locale, {style:'currency', currency:config.currency}).format(value / 100);
      $$('[data-price]').forEach(el => { el.textContent = money(v.price); });
      const compare = $('[data-compare]');
      compare.hidden = !(v.compare_at_price > v.price);
      compare.textContent = compare.hidden ? '' : money(v.compare_at_price);
      $('[data-stock]').textContent = config.labels[v.available ? 'available' : 'sold_out'];
      if (v.quantity_rule) {
        qty.min = v.quantity_rule.min || 1; qty.step = v.quantity_rule.increment || 1; qty.max = v.quantity_rule.max || '';
      }
      syncButtons();
      const url = new URL(location.href); url.searchParams.set('variant', v.id); history.replaceState({}, '', url);
    });
    on(form, 'submit', async (event) => {
      event.preventDefault();
      if (busy || !variant()?.available) return;
      syncQuantity();
      if (!form.reportValidity()) return;
      // Build the payload before disabling controls. Never retry an uncertain add automatically.
      const payload = new FormData(form);
      busy = true; syncButtons(); status.hidden = true;
      try {
        const response = await fetch(config.addUrl, {method:'POST', headers:{Accept:'application/json','X-Requested-With':'XMLHttpRequest'}, body:payload});
        const result = await response.json();
        if (!response.ok || result.status >= 400) throw new Error(result.description || config.labels.error);
        status.classList.remove('is-error');
        $('[data-cart-message]').textContent = config.labels.added;
        status.hidden = false;
        // The installed UpCart app observes this AJAX add; the bus also refreshes Dawn consumers.
        if (window.mwBus) { window.mwBus.emit('cart:updated', {source:'mw-tumbler', productVariantId:variantInput.value}); window.mwBus.emit('cart:open'); }
      } catch (error) {
        status.classList.add('is-error');
        $('[data-cart-message]').textContent = error.message && error.message !== 'Failed to fetch' && error.message !== 'Load failed' ? error.message : config.labels.error;
        status.hidden = false;
      } finally {
        busy = false; syncButtons();
      }
    });
    on(stickyButton, 'click', () => { if (!busy) form.requestSubmit(submit); });
    const sticky = $('.tm-sticky');
    let scrollTick = false;
    const updateSticky = () => {
      const rect = submit.getBoundingClientRect();
      const visible = rect.top < window.innerHeight && rect.bottom > 90;
      sticky.hidden = visible || window.scrollY < 220 || modal.open;
      scrollTick = false;
    };
    const scheduleSticky = () => { if (!scrollTick) { scrollTick = true; requestAnimationFrame(updateSticky); } };
    on(window, 'scroll', scheduleSticky, {passive:true});
    on(window, 'resize', () => { updateGallery(); scheduleSticky(); }, {passive:true});
    on(modal, 'close', scheduleSticky);
    on(modal, 'toggle', scheduleSticky);
    const observer = new IntersectionObserver(scheduleSticky, {threshold:[0,1]}); observer.observe(submit);
    syncButtons(); updateSticky();
    on(document, 'shopify:section:unload', event => {
      if (!event.target.contains(root)) return;
      if (modal.open) modal.close(); observer.disconnect(); abort.abort(); delete root.dataset.ready;
    });
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init, {once:true}); else init();
  document.addEventListener('shopify:section:load', init);
})();
